import { model } from "core/util";
import { Amount as AmountType, AmountDto } from "types";

export const Amount = model.createModel<AmountDto, AmountType>((json) => ({
    currencyCode: json.CurrencyCode,
    value: json.Value,
}));
